import { inject } from 'aurelia-framework';
import { AppendToFieldValuesOperation } from './operations/append-to-field-values.operation';
import { SetFieldValueOperation } from './operations/set-field-value.operation';
import { AddToExistingMediaBundle } from './operations/add-to-existing-media-bundle.operation';
import { RemoveFromMediaBundle } from './operations/remove-from-media-bundle.operation';
import { AiImageTagging } from './operations/ai-image-tagging.operation';
import { UpdateContingentCalendar } from './operations/update-contingent-calendar.operation';
import { TableRowActionsOperation } from './operations/table-row-actions.operation.js';
import { CreateMarginReportOperation } from './operations/create-margin-report.operation';
import { RemoveTag } from './operations/remove-tag.operation.js';

@inject(
    AppendToFieldValuesOperation,
    SetFieldValueOperation,
    AddToExistingMediaBundle,
    RemoveFromMediaBundle,
    TableRowActionsOperation,
    AiImageTagging,
    UpdateContingentCalendar,
    CreateMarginReportOperation,
    RemoveTag
)
export class BulkOperationsRepository {
    /** @var OperationInterface[] */
    operations;

    constructor(
        appendToFieldValuesOperation,
        setFieldValueOperation,
        addToExistingMediaBundle,
        removeFromMediaBundle,
        tableRowActionsOperation,
        aiImageTagging,
        updateContingentCalendar,
        createMarginReportOperation,
        removeTag
    ) {
        this.operations = {};

        this.addOperation(appendToFieldValuesOperation);
        this.addOperation(setFieldValueOperation);
        this.addOperation(addToExistingMediaBundle);
        this.addOperation(removeFromMediaBundle);
        this.addOperation(tableRowActionsOperation);
        this.addOperation(aiImageTagging);
        this.addOperation(updateContingentCalendar);
        this.addOperation(createMarginReportOperation);
        this.addOperation(removeTag);
    }

    /*private*/ addOperation(operation) {
        this.operations[operation.getName()] = operation;
    }

    /*public*/ getOperations() {
        return this.operations.slice(0);
    }

    /*public*/ getOperation(operationName) {
        if (undefined === this.operations[operationName]) {
            throw new Error(
                `Operation "${operationName}" is not registered in OperationsRepository`
            );
        }

        return this.operations[operationName];
    }

    /*public*/ execute(operationName, context) {
        if (undefined === this.operations[operationName]) {
            throw new Error(
                `Operation "${operationName}" is not registered in OperationsRepository`
            );
        }

        return this.operations[operationName].execute(context);
    }
}
